export var SharedVaultServiceEvent;
(function (SharedVaultServiceEvent) {
    SharedVaultServiceEvent["SharedVaultStatusChanged"] = "SharedVaultStatusChanged";
    SharedVaultServiceEvent["SharedVaultFileStorageUsageChanged"] = "SharedVaultFileStorageUsageChanged";
})(SharedVaultServiceEvent || (SharedVaultServiceEvent = {}));
